// Module
var code = "<md-content class=\"animated fadeIn\"> <div ng-style=\"{height: $ctrl.screenSize.height + 'px'}\" layout=\"row\" layout-align=\"center center\"> <md-progress-circular class=\"form-spinner\" md-mode=\"indeterminate\"> </md-progress-circular> </div> </md-content>";
// Exports
export default code;